import React, { useState, useEffect } from 'react'
import { Grid, Row, Col, Form, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import Card from 'Admin/components/Card/Card.jsx';
import Button from 'Admin/elements/CustomButton/CustomButton.jsx';
import { CSVLink } from "react-csv";
import Select from 'react-select';
import * as API from "Admin/api/clinic"
import { confirmAlert } from "react-confirm-alert";

const MigrateClinic = (props) => {
    const [clinicList, setClinicList] = useState([])
    const [isInValidPatientCsv, setIsInValidPatientCsv] = useState(true)
    const [formData, setFormData] = useState({ clinicId: "" });
    const [patientFile, setPatientFile] = useState(null);
    const [prescriptionFile, setPrescriptionFile] = useState(null);
    const [inValidData, setInvalidData] = useState(true)
    const [errorsData, setErrorsData] = useState([])
    const [csvData, setCsvData] = useState([])



    let csvPatientDetailHeaders = [
        { label: "Patient Id", key: "patientId" },
        { label: "Title", key: "title" },
        { label: "First Name", key: "firstName" },
        { label: "Gender", key: "gender" },
        { label: "Age", key: "age" },
    ];

    let csvPrescriptionDetailHeaders = [
        { label: "Patient Id", key: "patientId" },
        { label: "Drug Name", key: "drugName" },
        { label: "Drug Company", key: "drugCompany" },
        { label: "Drug Category", key: "drugCategory" },
        { label: "Drug Duration", key: "drugDuration" },
        { label: "Ingredients With Dose", key: "ingredientsWithDose" },
        { label: "Drug Instruction", key: "drugInstruction" },
        { label: "No Of DoseSelector", key: "noOfDoseSelector" },
        { label: "Prescription Date", key: "prescriptionDate" },
    ];

    let csvErrorDetailHeaders = [
        { label: "Patient Id", key: "patientId" },
        { label: "Title", key: "title" },
        { label: "First Name", key: "firstName" },
        { label: "Gender", key: "gender" },
        { label: "Age", key: "age" },
        { label: "Drug Name", key: "drugName" },
        { label: "Drug Company", key: "drugCompany" },
        { label: "Drug Category", key: "drugCategory" },
        { label: "Drug Duration", key: "drugDuration" },
        { label: "Ingredients With Dose", key: "ingredientsWithDose" },
        { label: "Drug Instruction", key: "drugInstruction" },
        { label: "Prescription Date", key: "prescriptionDate" },
    ];

    const getClinicList = async () => {
        let res = await API.clinicSimpleList()
        console.log(res, "response")
        if (res?.data?.status === "Success" && res?.data?.statusCode === 200) {
            let selArr = []
            selArr = res.data.data.map((obj, key) => {
                return { value: obj._id, label: `${obj.name}(${obj.clinicId})` };
            })
            let obj = { value: "", label: "Select Clinic" }
            selArr.unshift(obj)
            setClinicList([...selArr]);
        }
    }

    const handlePatientFile = (event) => {
        if (event.target.files.length > 0) {
            let formDataTemp = event.target.files[0];
            setPatientFile(formDataTemp);
            setIsInValidPatientCsv(false);
        }
    };

    const handlePrescriptionFile = (event) => {
        if (event.target.files.length > 0) {
            let formDataTemp = event.target.files[0];
            setPrescriptionFile(formDataTemp);
        }
    };

    const handleSubmit = async () => {
        console.log("handle Submit")
        let sentData = new FormData();
        sentData.append("patientFile", patientFile);
        sentData.append("prescriptionFile", prescriptionFile);
        try {
            //const response = awaitAPI.migrateClinic(sentData);

            // if (response.error) {
            //     throw new Error('Failed to upload data');
            // }
            // if (res.data.status === "Success" && res.data.statusCode === 200) {
            //     successAlert("Data Uploaded Successfully");
            //     setPatientFile(null)
            //     setPrescriptionFile(null)
            //     setIsInValidPatientCsv(true)
            // }
        } catch (error) {
            console.error('Error fetching data:', error.message);
            setInvalidData(true)
            //setErrorsData([...response?.data.data])
        }

    }

    const inputHandler = (e, field) => {
        if (e) {
            let saveFormData = formData
            saveFormData[field] = e?.value;
            setFormData({ ...saveFormData })
        } else {
            let saveFormData = formData
            saveFormData[field] = "";
            setFormData({ ...saveFormData })
        }


    }

    const uploadConfirm = () => {
        confirmAlert({
            title: "Confirm to upload",
            message: "Are you sure you want to upload?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        handleSubmit()
                    },
                },
                {
                    label: "No",
                },
            ],
        });
    };



    useEffect(() => {
        getClinicList()
        let errArr = [
            "A10051052-Gender should be required",
            "A10051123-Date of birth should be dd/mm/yyyy",
            "A10051249-Age should be required",
            "A10051323-Tittle should be required",
            "A10051341-First name should be required",
            "A10051247-Gender should be required",
            "A10051436-Phone should be required",
            "A10051489-Date of birth should be required",
            "A10051633-Age should be required"
        ]
        let arr = []
        for (let i = 0; i < errArr.length; i++) {
            arr.push([errArr[i]])
        }
        console.log(arr, "arrrrr")
        // { patientId: "A11451011", title: "Please Fill  Title", firstName: "Tomi", gender: "male", age: "Invalid age", drugName: "Olet 2.96", drugCompany: "AAA", drugCategory: "trops", drugDuration: '8 years', ingredientsWithDose: "New ingredients", drugInstruction: "new instruction", prescriptionDate: "date is missing" },
        // { patientId: "A11451078", title: "", firstName: "Tomi", gender: "male", age: "", drugName: "Axepta 10", drugCompany: "Eris", drugCategory: "tops", drugDuration: '8 years', ingredientsWithDose: "New ingredients", drugInstruction: "new instruction", prescriptionDate: "date is missing" },
        // { patientId: "A11451111", title: "", firstName: "Tomi", gender: "male", age: "", drugName: "Metolar XR-100", drugCompany: "AAA", drugCategory: "odds", drugDuration: '8 years', ingredientsWithDose: "New ingredients", drugInstruction: "new instruction", prescriptionDate: "date is missing" },
        // { patientId: "A1145191", title: "", firstName: "Tomi", gender: "male", age: "Please Fill Age", drugName: "Topacmac 200", drugCompany: "AAA", drugCategory: "trops", drugDuration: '8 years', ingredientsWithDose: "New ingredients", drugInstruction: "new instruction", prescriptionDate: "date is missing" },
        // { patientId: "A11451523", title: "Invalid Title", firstName: "Tomi", gender: "male", age: "", drugName: "arkamin 100", drugCompany: "YYY", drugCategory: "keys", drugDuration: '8 years', ingredientsWithDose: "New ingredients", drugInstruction: "new instruction", prescriptionDate: "Invalid Date Format" },


        setErrorsData([...arr])
    }, [])

    console.log(errorsData, "filess")

    return (
        <div className="main-content">
            <Grid fluid>
                <Row>
                    <Col sm={4}>
                        <FormGroup>
                            <Col componentClass={ControlLabel} >
                                Clinic:
                            </Col>
                            <Select
                                placeholder=""
                                name="clinicId"
                                id="selClinicId"
                                closeOnSelect={true}
                                multi={false}
                                value={formData.clinicId}
                                options={clinicList}
                                onChange={(e) => {
                                    inputHandler(e, "clinicId");
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={4}>
                        <FormGroup>
                            <Col componentClass={ControlLabel} >
                                Upload Patient File:
                            </Col>
                            <div className="clinic-file-up" disabled={formData.clinicId === "" ? true : false}>
                                <input
                                    type="file"
                                    accept=".csv"
                                    name="patientFile"
                                    autoComplete="off"
                                    onChange={(e) => handlePatientFile(e)}
                                    placeholder="File"
                                    title=" "
                                    style={{ color: "transparent", display: "inline-flex", width: "95px", marginRight: "10px" }}
                                />
                                <p style={{ fontSize: "14px", display: "inline-flex" }} id="patientFileName">{patientFile?.name ? patientFile?.name : "No File Chosen."}</p>
                            </div>
                            <CSVLink
                                headers={csvPatientDetailHeaders}
                                data={csvData}
                                filename={"PatientTemplate.csv"}
                                className=""
                            >
                                Download a sample patient template (CSV)
                            </CSVLink>
                        </FormGroup>

                    </Col>

                    <Col sm={4}>
                        <FormGroup>
                            <Col componentClass={ControlLabel} >
                                Upload Patient Prescription File:
                            </Col>
                            <div className="clinic-file-up" disabled={formData.clinicId === "" ? true : false || isInValidPatientCsv}>
                                <input
                                    type="file"
                                    accept=".csv"
                                    name="prescriptionFile"
                                    autoComplete="off"
                                    placeholder="File"
                                    onChange={(e) => handlePrescriptionFile(e)}
                                    style={{ color: "transparent", display: "inline-flex", width: "95px", marginRight: "10px" }}
                                />
                                <p style={{ fontSize: "14px", display: "inline-flex" }} id="patientFileName">{prescriptionFile?.name ? prescriptionFile?.name : "No File Chosen."}</p>
                            </div>
                            <CSVLink
                                headers={csvPatientDetailHeaders}
                                data={csvData}
                                filename={"PrescriptionTemplate.csv"}
                                className=""
                            >
                                Download a sample prescription template (CSV)
                            </CSVLink>
                        </FormGroup>
                    </Col>
                </Row>
                <Button type="button" disabled={patientFile === null || prescriptionFile === null || formData.clinicId === ""} onClick={uploadConfirm} fill bsStyle="info">Upload</Button>

                {inValidData &&
                    <div style={{ marginTop: "10px" }}>
                        <span style={{ color: "red" }}>Invalid Data Uploaded</span><br />
                        <CSVLink
                            //headers={csvErrorDetailHeaders}
                            data={errorsData}
                            filename={"erro.csv"}
                            className=""
                        >
                            Download error file here.
                        </CSVLink>
                    </div>
                }

            </Grid>
        </div>
    )
}

export default MigrateClinic
